// 분석 및 보고서(대표) API — 계약 backend docs/frontend-admin-v6-api-handoff.md §11
import { http, data } from "../../inquiry/v6Api";

const byDays = (path, days, extra) => data(http.get(path, { params: { days, ...extra } }));

export const getSummary = (days) => byDays("/analytics/reports/summary", days);
export const getCategories = (days) => byDays("/analytics/reports/categories", days);
export const getTopQuestions = (days) => byDays("/analytics/reports/top-questions", days, { limit: 5 });
export const getLanguages = (days) => byDays("/analytics/languages", days);
// 일별·시간대 대화량은 요약(getSummary)의 daily_conversations·hourly_usage 를 쓴다(§11)

// 날짜·제품별 줄(group=day_product) — 제품별 합계·일별 비용·날짜별 내역을 모두 여기서 더한다. cost_usd 는 문자열.
export const getCostDays = (keys) =>
    data(http.get("/api-cost/totals", { params: { start: keys[0], end: keys[keys.length - 1], group: "day_product" } }));

export const getRecentFiles = () => data(http.get("/knowledge/", { params: { offset: 0, limit: 5 } }));

export const exportCsv = (days) => data(http.get("/analytics/reports/export", { params: { days }, responseType: "blob" }));
